module.exports = __webpack_public_path__ + "media/airtrek.cef537b9.mp4";